import React, { useState } from "react";
import styled from "@emotion/styled";
import { setColor } from "../../../assets/styles/styles";
import { default as Button } from "../../../components/common/button/Button";
import Typography from "../../../components/common/text/Typography";
import { createUser } from "../../../api/UserController";

const AddUserModal = ({ setUserId }) => {
    const [email, setEmail] = useState("");
    const [displayName, setDisplayName] = useState("");

    const CreateUser = async () => {
        const data = {
            displayName,
            firstName: displayName,
            lastName: displayName,
            email,
            password: "TerraZero@123",
            createDefaultRoom: false,
        };
        const resp = await createUser(data);
        setUserId(resp?.userId);
    };

    return (
        <>
            <Card>
                <Typography variant="PinkHeading">Add User</Typography>
                <InputBox
                    type="text"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <InputBox
                    type="text"
                    placeholder="Enter Owner Name"
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                />
                <Button
                    variant={"PinkButton"}
                    label={"Create New User"}
                    margin={"1rem 0rem 0rem 0rem"}
                    onClick={CreateUser}
                />
            </Card>
        </>
    );
};

export default AddUserModal;

const Card = styled.div`
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const InputBox = styled.input`
    padding: 10px;
    border: ${(props) => (props.errorMessage ? `1px solid ${setColor.errorColor}` : `1px solid ${setColor.grey1}`)};
    border-radius: 5px;
    color: ${setColor.inputText};
    margin: 1rem 0rem 0rem 0rem;
    width: ${(props) => (props.width ? props.width : "100%")};
    background-color: transparent;
    margin-bottom: ${(props) => (props.errorMessage ? "0.5rem" : "0rem")};
    &:disabled {
        background-color: ${setColor.grey1};
    }
`;
